const TICK_MILLISECONDS = 1000;
/**
 * Counts down to the sign-in's `resendAllowedAt`. Each tick recomputes the value from the clock instead of
 * subtracting 1, so a tab that was in the background shows the right value as soon as it ticks again.
 */
export class ResendCountdown {
    clock;
    intervalTimer;
    intervalHandle = undefined;
    constructor(clock, intervalTimer) {
        this.clock = clock;
        this.intervalTimer = intervalTimer;
    }
    findResendAllowedAt(secondsUntilResend) {
        return new Date(this.clock.now().getTime() + secondsUntilResend * TICK_MILLISECONDS);
    }
    follow(signIn) {
        this.stop();
        if (this.writeSecondsUntilResend(signIn) > 0) {
            this.intervalHandle = this.intervalTimer.start(TICK_MILLISECONDS, () => this.tick(signIn));
        }
    }
    stop() {
        this.intervalHandle?.stop();
        this.intervalHandle = undefined;
    }
    tick(signIn) {
        if (this.writeSecondsUntilResend(signIn) === 0) {
            this.stop();
        }
    }
    writeSecondsUntilResend(signIn) {
        const resendAllowedAt = signIn.resendAllowedAt.get();
        let secondsUntilResend = 0;
        if (resendAllowedAt !== null) {
            secondsUntilResend = Math.max(0, Math.ceil((resendAllowedAt.getTime() - this.clock.now().getTime()) / TICK_MILLISECONDS));
        }
        signIn.updateSecondsUntilResend(secondsUntilResend);
        return secondsUntilResend;
    }
}
//# sourceMappingURL=ResendCountdown.js.map